import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useCurrencies } from 'modules/payroll_bundle/hooks/useCurrencies'

interface Props {
  onChange: (value: string) => void
  currencyValue: string
}

const CurrencySelector = ({ onChange, currencyValue }: Props) => {
  const { loading: loadingCurrencies, currencies } = useCurrencies()

  const options = currencies.map((currency) => {
    return {
      label: currency.isoCode,
      subtitle: `${currency.symbol} ${currency.name}`,
      value: currency.isoCode,
    }
  })

  const currencyOptions = options.map(({ label, value, subtitle }) => (
    <Selector.Option label={value} searchValue={value} key={value} value={value}>
      <Box flexDirection="column">
        <Text.Normal weight="medium">{label}</Text.Normal>
        <Text.Normal size="200" weight="normal" color="grey600">
          {subtitle}
        </Text.Normal>
      </Box>
    </Selector.Option>
  ))

  const handleCurrencyChange = (value: string) => {
    onChange(value)
  }

  return (
    <Selector.Popover
      headerLabel={i18n.t('common.all')}
      placeholder={i18n.t('common.select')}
      label={i18n.t('payroll_bundle.onboarding.payroll_policy_step.currency_selector')}
      blankLabel={i18n.t('common.empty')}
      onChange={(value) => handleCurrencyChange(value as string)}
      value={currencyValue ? [currencyValue] : []}
      searchPlaceholder={i18n.t('common.search')}
      isDisabled={false}
      loading={loadingCurrencies}
    >
      {currencyOptions || []}
    </Selector.Popover>
  )
}

export default observer(CurrencySelector)
